<template>
  <v-row justify="center">
    <v-col cols="12" lg="4">
      <v-card outlined v-if="location.address !== null" data-testid="location-address">
        <v-card-title>{{ $t('address') }}</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <span>{{ location.address.addressLine1 }}</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" v-if="location.address.addressLine2 !== ''">
              <span>{{ location.address.addressLine2 }}</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <span>{{ `${location.address.city}, ${location.address.state}` }}
                {{ location.address.postalCode }}</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" v-if="location.address.addressLine2 === ''">
              <span><br /></span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <span v-else>{{ $t('noAddressDefined') }}</span>
    </v-col>

    <v-col cols="12" md="6" lg="4">
      <v-card outlined v-if="location.mainContact !== null" data-testid="location-main-contact">
        <v-card-title>{{ $t('mainContact') }}</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <span>{{ `${location.mainContact.firstName} ${location.mainContact.lastName}` }}</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <span>{{ convertToValidPhoneNumber(location.mainContact.phoneNumber) }}</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <span>{{ location.mainContact.email }}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <span v-else>{{ $t('noMainContactDefined') }}</span>
    </v-col>

    <v-col cols="12" md="6" lg="4">
      <v-card outlined v-if="location.ticketContact !== null" data-testid="location-ticket-contact">
        <v-card-title>{{ $t('ticketContact') }}</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <span>{{ `${location.ticketContact.firstName} ${location.ticketContact.lastName}` }}</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <span>{{ convertToValidPhoneNumber(location.ticketContact.phoneNumber) }}</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <span>{{ location.ticketContact.email }}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <span v-else>{{ $t('noTicketContactDefined') }}</span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'LocationContactCards',

  props: {
    location: {
      type: Object,
      required: true
    }
  },

  methods: {
    convertToValidPhoneNumber (phoneNumberString) {
      const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        return '(' + match[1] + ')- ' + match[2] + '-' + match[3]
      }
      return ''
    }
  }
}
</script>
